(function($){
    $(document).ready(function(){
        if($('.page-wishlist .tinv-wishlist.woocommerce').length > 0){
            $('.page-wishlist .tinv-wishlist.woocommerce .return-to-shop a').attr('href', '/nowosci/');
        }
        if($('.woocommerce-MyAccount-content').length > 0){
            $('.woocommerce-Button.button').attr('href', '/nowosci/');
        }
        $('body').on('click', '.tinvwl_add_to_wishlist_button', function(){
            $('.woocommerce-notices-wrapper .woocommerce-message').remove();
            var html = '';
            if($(this).hasClass('tinvwl-product-make-remove')){
                html = '<p>Produkt '+$('.product_title').html()+' usunięty z listy życzeń</p>';
            }
            else{
                if(!$(this).hasClass('disabled-add-wishlist')) {
                    html = '<p>Produkt ' + $('.product_title').html() + ' dodany do listy życzeń</p><a href="/wishlist/">Zobacz listę życzeń</a>';
                }
                else{
                    html = '<p>Wybierz najpierw wariant produktu</p>';
                }
            }
            $('.woocommerce-notices-wrapper').append('<div class="woocommerce-message wishlist-alert" role="alert"><div class="added-to-cart-info">'+html+'</div></div>');
        });
        setInterval(function(){
            // $('.woocommerce-notices-wrapper .wishlist-alert').remove();
            if($('.tinvwl_added_to_wishlist').length > 0){
                if($('.tinvwl_added_to_wishlist .icon_big_times').length > 0){
                    console.log('wusu');
                }
                else{
                    console.log('wdod')
                }
            }
        }, 150)
    });

})(jQuery)